module.exports = __webpack_public_path__ + "img/image15.ebf7926c.png";